import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-bhaktniwas-inquiries',
  templateUrl: './bhaktniwas-inquiries.component.html',
  styleUrls: ['./bhaktniwas-inquiries.component.scss']
})
export class BhaktniwasInquiriesComponent implements OnInit {
public inquiriesList: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public perPage = 10;
  public totalCount = 0;
  public page = 1;
  public maxDate =  '';
  public search: string = '';
  public filteredInquiries: any[] = [];
  public selectedRequestId: any = null;
  public actionRemark: string = '';
  public actionTaken: ''; 

  constructor(
    private apiService: ApiService,
    private appComponet: AppComponent,
    public permissionsService: PermissionsService,
    private appComponent: AppComponent, 
    private modalService: NgbModal
    ) { }
    

  ngOnInit() {
    this.getList('');
  }

  onActionFilterChange() {
    this.page = 1;
    this.getList('');
  }

  onSearchChange() {
    this.page = 1;
    this.getList('');
  }

  getList(_type) {
    this.appComponet.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/bhaktniwas_inquiries?from_date=${from_date}&end_date=${to_date}&page=${this.page}&perpage=${this.perPage}&search=${this.search}&action_taken=${this.actionTaken}`).subscribe(
      (res: any) => {
        this.appComponet.hideLoader();
        this.inquiriesList = res;
        this.inquiriesList.data.map(res => {
          res.date = moment.utc(res.date).local().format('DD-MM-yyyy');
        });
        this.totalCount = res.total;
      },
      err => {
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        this.appComponet.hideLoader();
        console.log(err);
      }
    );
  }

  filterInquiries() {
    this.filteredInquiries = this.inquiriesList.filter(inquiry => {
        return inquiry.propertyName.toLowerCase().includes(this.search.toLowerCase());
    });
  }

  openActionModal(content: any, requestId: number) {
    this.selectedRequestId = requestId;
    this.actionRemark = '';
    this.modalService.open(content, { backdrop: 'static', centered: true });
  }

  submitAction(modal: any) {
        this.appComponent.showLoader();

        const body = {
            action_remarks: this.actionRemark
        };

        this.apiService.postDataToServer(
            `/bhaktniwas_inquiries/${this.selectedRequestId}/mark_action`,
            body
        ).subscribe(
            (res: any) => {
            this.appComponent.hideLoader();
            modal.close();
            this.appComponent.showMessageAlert('Action marked successfully', 'success');
            this.getList('');
            },
            (error) => {
            this.appComponent.hideLoader();
            this.appComponent.showMessageAlert('Failed to mark action', 'error');
            console.log(error);
            }
        );
    }

    exportList() {
        this.appComponent.showLoader();
        const from_date = moment(this.from_date).format('YYYY-MM-DD');
        const to_date = moment(this.to_date).format('YYYY-MM-DD');
        
        this.apiService.getDataFromServer(`/export_bhaktniwas_inquiries?from_date=${from_date}&end_date=${to_date}`).subscribe(
            (res: any) => {
                this.appComponent.hideLoader();
                if(res.status_code === 200) {
                    const imageArry = res.data.split('/uploads');
                    fileSaver.saveAs(res.data, imageArry[1]);
                }
            },
            err => {
                this.appComponent.hideLoader();
                this.appComponent.showMessageAlert('Failed to export data', 'error');
                console.log(err);
            }
        );
    }

}
